import { UserProject } from '@types';
import { memo } from 'react';
import BaseUserTable from './BaseUserTable';

export interface ProjectsTableProps {
  data?: UserProject[];
}

const ProjectsTable = ({ data }: ProjectsTableProps) => {
  return <BaseUserTable data={data} />;
};

export default memo(ProjectsTable);
